async function apiRequest<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const response = await fetch(
    `${import.meta.env.VITE_EXPONENTIAL_API_URL}${endpoint}`,
    // `https://api.coinharbour.xyz${endpoint}`,
    {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );

  return response.json();
}

export default apiRequest;
